import * as React from "react";
import {translate} from 'react-i18next';
import { Table } from "semantic-ui-react";

// reducer
import {ITranslatedComponent} from "../redux/reducers/generalReducer";

import {ResourceListOfModelyearDto, ModelyearDto} from "../services/Client";
import ColumnFactory from "../services/ColumnFactory";

// components
import SelectField from "./SelectField";

export interface IModelYearsControlProps extends ITranslatedComponent {
    /** All model years available in the select control. */
    modelyears: ResourceListOfModelyearDto | ModelyearDto[];

    /** Pre-selected item in the select control. */
    selectedItem?: ModelyearDto;

    /** Call back for when a model year has been selected. */
    selectionChanged: (dto: ModelyearDto) => void;

    id?:string;
}

export class ModelYearsControl extends React.Component<IModelYearsControlProps> {
    constructor(props: IModelYearsControlProps) {
        super(props);
        this.state = {selectedItem: props.selectedItem};
    }

    componentWillReceiveProps(newProps: IModelYearsControlProps) {
        if (newProps.selectedItem !== this.props.selectedItem) {
            this.setState({selectedItem: newProps.selectedItem});
        }
    }

    getModelyearElements = (props: IModelYearsControlProps): ModelyearDto[] => {
        const isResList = (x: ResourceListOfModelyearDto | ModelyearDto[]): x is ResourceListOfModelyearDto => (
            (x as ResourceListOfModelyearDto).elements !== undefined
        );
        if (isResList(props.modelyears)) {
            return props.modelyears.elements || [];
        }
        if (Array.isArray(props.modelyears)) {
            return props.modelyears;
        }
        throw new Error("Invalid model year type");
    }

    createSelectedItemValue = (dto: ModelyearDto): string => (
        ColumnFactory.mj2str(dto)
    )

    onSelectionChanged = (selectedValue?: ModelyearDto, selectedIndex?: number) => {
        if (selectedValue !== undefined) {
            this.props.selectionChanged(selectedValue);
        }
    }

    render() {
        const modelyears = this.getModelyearElements(this.props);

        if (modelyears.length === 0) {
            // return 'invalid' select field
            return (
                <SelectField
                    placeholder={this.props.t("MODELYEAR")}
                    value={this.props.t("NO_MODELYEARS")}
                    disabled={true}
                    dataSource={[this.props.t("NO_MODELYEARS")]}
                />
            );
        }
        let headerStyle: React.CSSProperties = { textAlign: 'left', fontWeight: 'normal' };
        const style =
        {
            width: '100%'
        };
        const header =
            (
                <thead>
                    <tr>
                        <th colSpan={1} style={headerStyle}>{this.props.t('SELECT_MODELYEAR') + ':'}</th>
                    </tr>
                </thead>
            );
        const cont = (
            <table style={style}>
                {header}
                <SelectField
                    id={this.props.id}
                    placeholder={this.props.t("MODELYEAR")}
                    dataSource={modelyears}
                    value={this.props.selectedItem}
                    searchable={false}
                    clearable={false}
                    onChange={this.onSelectionChanged}
                    rendererKey={this.createSelectedItemValue}
                />
            </table>

        );
        return (
            <Table>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>
                            {cont}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }
}

export default translate("GLOBAL")(ModelYearsControl);



// WEBPACK FOOTER //
// ./src/components/ModelYearsControl.tsx